import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
interface PageBannerProps {
  title: string;
  subtitle?: string;
}
export function PageBanner({
  title,
  subtitle
}: PageBannerProps) {
  return <section className="relative pt-48 pb-12 lg:pb-20 overflow-hidden bg-[#F8FAFC] border-b border-gray-100" aria-label={title} data-id="element-161">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-id="element-162">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#4AA6CF08_1px,transparent_1px),linear-gradient(to_bottom,#4AA6CF08_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-40" data-id="element-163" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#4AA6CF] rounded-full mix-blend-multiply filter blur-[180px] opacity-[0.03]" data-id="element-164" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-166">
          {/* Breadcrumb */}
          <nav aria-label="Breadcrumb" className="flex items-center justify-center gap-3 text-sm text-slate-400 mb-10 font-bold uppercase tracking-widest" data-id="element-167">
            <Link to="/" className="hover:text-[#4AA6CF] transition-colors" data-id="element-168">
              Home
            </Link>
            <ChevronRightIcon className="h-4 w-4 text-slate-300" aria-hidden="true" data-id="element-169" />
            <span className="text-[#4AA6CF]" aria-current="page" data-id="element-170">
              {title}
            </span>
          </nav>

          <h1 className="text-5xl md:text-6xl lg:text-8xl font-extrabold text-slate-900 mb-8 tracking-tight" data-id="element-171">
            {title}
          </h1>

          {subtitle && <p className="text-xl md:text-2xl text-slate-600 max-w-3xl mx-auto font-normal leading-relaxed" data-id="element-172">
              {subtitle}
            </p>}
        </motion.div>
      </div>
    </section>;
}